<script>
import { isMobileOnly } from 'mobile-device-detect'
export default {
  name: 'MobileDetector',
  computed: {
    isMobile () {
      return isMobileOnly
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/front/components/common/MobileDetector.vue